module.exports = __webpack_public_path__ + "static/media/signup-provider-work-experience-info-fi.bbe3e271.png";